import { Router } from "@reach/router";

import Home from "./Home/Home";
import Form from "./Form/Form";
import EHR from "./EHR/EHR";
import EHRV2 from "../EHR/V2/EHR";
import Facturar from "./Facturar/Facturar";

const Consumers = () => {
  return (
    <Router>
      <Home path="/" />
      <EHRV2 path=":consumerID/ehr/v2/*" />
      <EHR path=":consumerID/ehr/*" />
      {/* Facturación en lote (§negocio 2026-08-04) — segmento estático,
          gana contra el catch-all ":consumerID/*" de Form de abajo. */}
      <Facturar path=":consumerID/facturar/*" />
      <Form
        path=":consumerID/*"
        className="container p-4 my-4 shadow bg-white rounded"
        source="home"
      />
    </Router>
  );
};

export default Consumers;
